import { createAction } from "@reduxjs/toolkit";
import axios from 'apis';
import { asyncThunkWrapper } from "helpers/asyncThunkWrapper";

export const getSecondAnalyses = asyncThunkWrapper({ 
  model: 'secondAnalyses', 
  action: 'getSecondAnalyses', 
  func: async ({ offset = 0 }) => {
    const attributes = ['id', { input: ['id', 'filename'] }, 'status', 'updated_at'];
    const params = { limit: 25, offset, orders: { updated_at: 'desc' }, attributes };
    const response = await axios.get('/second_flow/second_analyses', { params });

    return response.data;
  } 
});
export const getSecondAnalysis = asyncThunkWrapper({ 
  model: 'secondAnalyses', 
  action: 'getSecondAnalysis', 
  func: async ({ id, cable = false }) => {
    const attributes = [
      'id', 
      { input: ['id', 'filename', 'content_type', 'url'] },
      { document: ['id', 'filename', 'content_type', 'url'] }, 
      { result: ['id', 'filename', 'content_type', 'url'] }, 
      'status', 
      'updated_at'
    ];
    const params = { attributes };
    const response = await axios.get(`/second_analyses/${id}`, { params });

    return { data: response.data, cable };
  } 
});
export const createSecondAnalysis = asyncThunkWrapper({ 
  model: 'secondAnalyses', 
  action: 'createSecondAnalysis', 
  func: async (second_analysis) => {
    const attributes = ['id', { input: ['id', 'filename'] }, 'status', 'updated_at'];
    const response = await axios.post(`/second_flow/second_analyses`, { second_analysis, attributes });

    return response.data;
  } 
});
export const clearLocalSecondAnalyses = createAction('secondAnalyses/clearLocalSecondAnalyses');
export const clearLocalActiveSecondAnalysis = createAction('secondAnalyses/clearLocalActiveSecondAnalysis');